module.exports = __webpack_public_path__ + "static/img/icon_tenge.968495af.svg";